import { DefaultTheme } from 'styled-components'
import { BigNumber } from 'ethers'
import { AssetItem } from 'components/Portfolios/AssetComposition/types'
import { CurrencyValue } from '@usedapp/core'
import { ZeroCurrencyValue } from 'constants/currency'

export const getAssetItems = (
  liquidAssets: CurrencyValue,
  outstandingPrincipal: CurrencyValue,
  outstandingInterest: CurrencyValue,
  theme?: DefaultTheme,
): AssetItem[] => {
  const totalValue = liquidAssets.add(outstandingPrincipal).add(outstandingInterest)
  const calculateShare = (value: CurrencyValue) => {
    const divisor = totalValue.gt(ZeroCurrencyValue(totalValue.currency)) ? totalValue.value : BigNumber.from(1)
    const share = value.value.mul(100).div(divisor)

    if (share.isZero() && !value.isZero()) {
      return 1
    }

    return share.toNumber()
  }

  return [
    {
      label: 'Liquid Assets',
      value: liquidAssets,
      tooltip:
        'Liquid assets represent the amount of invested assets current locked in the on-chain vault. This can include assets that have been committed and not yet deployed as well as assets that have been deployed off-chain and returned to the on-chain vault. Fees are accrued against all assets in the vault, including liquid assets.',
      color: theme?.colors.OxidizedGreen,
      share: calculateShare(liquidAssets),
    },
    {
      label: 'Outstanding Principal',
      value: outstandingPrincipal,
      tooltip:
        'Outstanding principal represents the amount of capital currently deployed by the asset manager outside of the vault. Fees are accrued against all assets in the vault, including the outstanding principal.',
      color: theme?.colors.MonteCarlo,
      share: calculateShare(outstandingPrincipal),
    },
    {
      label: 'Outstanding Interest',
      value: outstandingInterest,
      tooltip:
        'Outstanding interest represents the return on the outstanding principal balance as represented by capital updates provided by the asset manager and their fund administrator. Fees are accrued against all assets in the vault, including the outstanding interest.',
      color: theme?.colors.Emerald,
      share: calculateShare(outstandingInterest),
    },
  ]
}
